import './Profile.css';

import { Fragment } from "react";
import { observer } from "mobx-react-lite";
import { AppStore } from "app";
import { RmdLogo } from "shared/ui/RmdLogo";
import { HeaderAccount } from "widgets/HeaderAccount";
import { Tabs } from 'widgets/Tabs';
import { StationsSummary } from "features/StationsLive";

import { RmdPage } from '../RmdPage';

export const Profile = observer(() => {
  const appStore = AppStore.getShared();
  const { authProcess: { authStore, ...rest } } = AppStore.getShared();

  return (
    <Fragment>
      <RmdPage
        headerLeft={""}
        headerMiddle={<RmdLogo />}
        headerRight={
          <HeaderAccount authProcess={appStore.authProcess} />
        }
        body={
          <main className="profile-page">
            <Tabs />
            <StationsSummary />
          </main>
        }
      />
    </Fragment>
  );
});